import axios from 'axios';
import { setAuthenticatedUser } from '../redux/userSlice';
import { isLogoutInProgress } from './sessionAuth';
import { setTracedUser } from '../utils/sessionTrace';

export function isAuthenticatedUserLoaded(user) {
  return Boolean(user && typeof user === 'object' && user.id);
}

export function formatAuthenticatedUserName(user) {
  if (!isAuthenticatedUserLoaded(user)) {
    return '';
  }

  const first = user.first_name ?? '';
  const last = user.last_name ?? '';
  return `${first} ${last}`.trim();
}

/**
 * Reloads the connected user from auth/me into Redux (permissions, regions, sites, …).
 * Used after role credential or self profile changes so the sidebar reflects new rights.
 */
export async function refreshAuthenticatedUser(dispatch) {
  if (isLogoutInProgress() || !localStorage.getItem('token')) {
    return false;
  }

  const { status, data } = await axios.get('auth/me');
  if (status === 200 || status === 201) {
    dispatch(setAuthenticatedUser(data));
    setTracedUser({ userId: data?.id, email: data?.email });
    return true;
  }

  return false;
}
